/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Leveling_Pictures_WriteInputs */



/**
* | output |
* | --- |
* | "Review member pictures and reset cards" |
*
* @param {Perm_Product_Leveling_Pictures_WriteInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_leveling_pictures_write = /** @type {((inputs?: Perm_Product_Leveling_Pictures_WriteInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Leveling_Pictures_WriteInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверять картинки участников и сбрасывать карточки")
	return /** @type {LocalizedString} */ ("Review member pictures and reset cards")
});